type Listener = (value: string) => void

export class InputPane {
  private listeners: Listener[] = []
  private debounceTimer: number | null = null

  constructor(
    private textarea: HTMLTextAreaElement,
    private counter: HTMLElement,
  ) {
    this.textarea.addEventListener('input', () => this.handleInput())
  }

  setValue(value: string): void {
    this.textarea.value = value
    this.handleInput()
  }

  getValue(): string {
    return this.textarea.value
  }

  onChange(listener: Listener): void {
    this.listeners.push(listener)
  }

  setCount(n: number): void {
    this.counter.textContent = `${n} ${n === 1 ? 'account' : 'accounts'}`
  }

  private handleInput(): void {
    if (this.debounceTimer !== null) window.clearTimeout(this.debounceTimer)
    this.debounceTimer = window.setTimeout(() => {
      const value = this.textarea.value
      for (const l of this.listeners) l(value)
    }, 200)
  }
}

export class OutputPane {
  private filename = 'output.txt'

  constructor(
    private textarea: HTMLTextAreaElement,
    private counter: HTMLElement,
    private copyBtn: HTMLButtonElement,
    private downloadBtn: HTMLButtonElement,
  ) {
    this.copyBtn.addEventListener('click', () => {
      void this.copy()
    })
    this.downloadBtn.addEventListener('click', () => this.download())
  }

  setOutput(value: string, count: number, filename: string): void {
    this.textarea.value = value
    this.counter.textContent = `${count} ${count === 1 ? 'account' : 'accounts'}`
    this.copyBtn.disabled = !value
    this.downloadBtn.disabled = !value
    this.filename = filename
  }

  clear(): void {
    this.textarea.value = ''
    this.counter.textContent = '0 accounts'
    this.copyBtn.disabled = true
    this.downloadBtn.disabled = true
  }

  private async copy(): Promise<void> {
    if (!this.textarea.value) return
    await navigator.clipboard.writeText(this.textarea.value)
    const original = this.copyBtn.textContent
    this.copyBtn.textContent = '✓ Copied'
    window.setTimeout(() => {
      this.copyBtn.textContent = original
    }, 1500)
  }

  private download(): void {
    if (!this.textarea.value) return
    const blob = new Blob([this.textarea.value], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = this.filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }
}
